const initialState = {
  materialList: null,
  loading: true,
  materialsModal: false
}

export default initialState
